import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchOnboardingDocumentTableAndFilterSchema } from "model/OnboardingDocumentModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const OnboardingDocumentContext = createContext();

export const OnboardingDocumentProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [onboardingDocumentContextData, setOnboardingDocumentContextData] = useState();

    const fetchOnboardingDocumentContextData = async () => {
        setLoading(true);
        try {
            const response = await fetchMetadataSchema(
                "metadata:onboardingDocuments",
                () => fetchOnboardingDocumentTableAndFilterSchema([])
            );
            if (response?.success) {
                setOnboardingDocumentContextData(response?.data);
            } else {
                setError(response?.message || "Unable to fetch onboarding documents metadata");
                toast.error(response?.message || "Unable to fetch onboarding documents metadata");
            }
        } catch (err) {
            setError(err);
            toast.error(err?.message || "Failed to load onboarding documents metadata");
        } finally {
            setLoading(false);
        }
    };

    return (
        <OnboardingDocumentContext.Provider
            value={{
                fetchOnboardingDocumentContextData,
                onboardingDocumentContextData,
                loading,
                error,
            }}
        >
            {children}
        </OnboardingDocumentContext.Provider>
    );
};

export const useOnboardingDocumentContext = () => useContext(OnboardingDocumentContext);
